import { xray } from 'lib/xray';
import { overquotaThresholdLabel } from 'reactApp/appHelpers/featuresHelpers/features/overquotaStates';
import { getAccountDwhChains } from 'reactApp/modules/dwh/dwh.helpers';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';
import type { QuotaStates } from 'server/types/context/IUser';

export const sendOverquotaInfo = ({
    overquotaResolve,
    overquotaStatus,
    stopProcessing,
    threshold = 'none',
}: {
    overquotaResolve: boolean;
    overquotaStatus: QuotaStates | 'failedapi' | undefined;
    stopProcessing: boolean;
    threshold?: number | 'none' | 'empty';
}) => {
    const { dwhData: accountDwhData, dwhChains: accountDwhChains } = getAccountDwhChains();

    const platform = getPlatformInfo().join('_');

    const dwhData = {
        status: overquotaStatus || 'none',
        resolve: overquotaResolve,
        stop: stopProcessing,
        ovqt_label: overquotaThresholdLabel,
        ovqt_thld: threshold,
        platform,
        ...accountDwhData,
    };

    const baseDwhChains: (keyof typeof dwhData)[][] = [['used', 'status', 'resolve', 'stop', 'platform']];
    const threshholdChain: (keyof typeof dwhData)[][] = [['used', 'status', 'ovqt_thld', 'ovqt_label']];
    const dwh_enabled_fields = [...baseDwhChains, ...threshholdChain, ...accountDwhChains];

    xray.send('overquota-info', {
        dwh_enabled: true,
        dwh_enabled_fields,
        dwh: dwhData,
    });
};
